(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('FeeDialogController', FeeDialogController);

    FeeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Fee'];

    function FeeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Fee) {
        var vm = this;

        vm.fee = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.fee.id !== null) {
                Fee.update(vm.fee, onSaveSuccess, onSaveError);
            } else {
                Fee.save(vm.fee, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:feeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
